import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { AccommodationTypePipe } from './accommodation-type.pipe';

@NgModule({
	declarations: [AccommodationTypePipe],
	exports: [AccommodationTypePipe],
	imports: [CommonModule, TranslateDirective, TranslatePipe],
})
export class AccommodationTypeModule {}
